import createEnum from 'scripts/lib/create_enum';

const RoutingItemType = createEnum(
  'ABANDONED_CALL',
  'AGENT_REQUEST',
  'AUTOMATED_ASSIGNMENT',
  'BLIND_TRANSFER',
  'CALL_DEVICE_ERROR',
  'CUSTOMER_ASSIGNEE_ASSIGNMENT',
  'CUSTOMER_ASSIGNEE_CHANGE',
  'DECLINED_CALL',
  'DECLINED_CHAT',
  'DECLINED_FB_MESSAGE',
  'DECLINED_OVER_CAPACITY_CHAT',
  'DECLINED_REASSIGNED_CHAT',
  'DECLINED_SMS',
  'DECLINED_TWITTER',
  'DECLINED_WHATSAPP',
  'INCOMING_CALL',
  'INCOMING_CHAT',
  'INCOMING_EMAIL',
  'INCOMING_FB_MESSAGE',
  'INCOMING_INSTAGRAM_DIRECT',
  'INCOMING_SMS',
  'INCOMING_TASK',
  'INCOMING_TWITTER',
  'INCOMING_WHATSAPP',
  'MANUAL_ASSIGNMENT',
  'MISSED_CALL',
  'MISSED_CHAT',
  'MISSED_FB_MESSAGE',
  'MISSED_SMS',
  'MISSED_TWITTER',
  'MISSED_WHATSAPP',
  'OFFER_CONFLICT',
  'OUTGOING_CALL',
  'OUTGOING_CHAT',
  'OUTGOING_EMAIL',
  'OUTGOING_FB_MESSAGE',
  'OUTGOING_SMS',
  'OUTGOING_TWITTER',
  'OUTGOING_WHATSAPP',
  'QUEUED_TRANSFER',
  'REASSIGNED_CHAT',
  'REROUTED_OFFLINE',
  'REROUTED_UNASSIGNED',
  'SLA_UPDATE',
  'UNASSIGNED_OFFLINE',
  'VOICEMAIL'
);

export default RoutingItemType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/routing_item_type.js